import axios from 'axios'

// 用户登录
export function login(phone, password, loginLocation) {
    return axios({
        url: '/auth/login',
        method: 'post',
        data: {
            phone,
            password,
            loginLocation
        }
    })
}

// 用户登出
export function logout() {
    return axios({
        url: '/auth/logout',
        method: 'post'
    })
}

// 用户注册
export function register(userData) {
    return axios({
        url: '/auth/register',
        method: 'post',
        data: userData
    })
}

// 修改密码 (从user/index.js移动到这里，因为这是认证相关的功能)
export function changePassword(passwordData) {
    return axios({
        url: `/auth/changePassword`,
        method: 'post',
        data: passwordData
    })
}

// 根据姓名和身份证号查询用户ID
export function findUserIdByNameAndIdCard(name, idCardNumber) {
    return axios({
        url: `/auth/findUserId`,
        method: 'get',
        params: {
            name,
            idCardNumber
        }
    })
}

// 验证Token
export function verifyToken() {
    return axios({
        url: '/auth/verifyToken',
        method: 'post'
    })
}

// 刷新Token
export function refreshToken() {
    return axios({
        url: '/auth/refreshToken',
        method: 'post'
    })
}
